<template>
    <v-select
      :items="items"
      :label="label"
      :hint="hint"
      :readonly="readonly"
      :value="beanname"
      :rules="requiredRules"
      @change="changeItem"
      @input="changeItem"
    >
      <template v-slot:no-data>
        {{$t('warnings.no_data_found')}}
      </template>
    </v-select>
</template>
<script>
import { requiredRules } from '../../utils/rules'
import BeansService from '../../services/BeansService'

export default {

  name: 'BeanSelect',

  methods: {
    changeItem (event) {
      this.$emit('change', event)
    }
  },

  computed: {
    requiredRules () {
      return this.required ? requiredRules(this.value) : []
    }
  },

  data: () => {
    return {
      items: []
    }
  },

  model: {
    prop: 'beanname',
    event: 'change'
  },

  props: {
    label: {
      type: String,
      default: 'Bean'
    },
    hint: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    classtype: {
      type: String,
      default: null
    },
    beanname: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    if (this.classtype === null || !this.classtype) {
      this.items = []
    } else {
      BeansService.findByClasstype(this.classtype)
        .then(response => {
          if (response && response.data) {
            this.items = response.data
          } else {
            this.items = []
          }
        })
        .catch(error => {
          console.error(`${this.$t('warnings.error.occurred')} : ${error}`)
        })
    }
  }
}
</script>
